export default () => ({
  setHeight() {
    if (window.innerWidth < 1024) {
      const height = window.innerHeight;
      this.$refs.wrapper &&
        (this.$refs.wrapper.style.height = `${height - 80}px`);
      this.$refs.imageWrapper &&
        (this.$refs.imageWrapper.style.marginTop = `${-height + 120}px`);
    }
  },
});
